// extracted by mini-css-extract-plugin
export default {"heading":"Modal_heading__Pj1MA","close":"Modal_close__V34Fj","title":"Modal_title__3HkNf","wrapper":"Modal_wrapper__TlE5n"};